import { combineReducers } from 'redux';
import bookmarkReducer from '../features/bookmark/bookmarkSlice';
import notificationToastReducer from '../features/notifications-toast/notificationToastSlice';
import profileReducer from '../features/profile/profileSlice';
import trackingReducer from '../features/tracking/trackingSlice';
import feedReducer from './feedReducer';
import globalModalReducer from './globalModalReducer';
import lastActionReducer from './lastActionReducer';
import searchReducer from './searchReducer';
import userMatchesReducer from './userMatchesReducer';

const appReducer = combineReducers({
  feed: feedReducer,
  bookmarkInfo: bookmarkReducer,
  profile: profileReducer,
  globalModal: globalModalReducer,
  matches: userMatchesReducer,
  searchData: searchReducer,
  lastAction: lastActionReducer,
  notificationToasts: notificationToastReducer,
  tracking: trackingReducer
});

export default (state, action) => {
  if (action.type === 'SIGN_OUT') {
    return appReducer({ searchData: state.searchData }, action);
  }

  return appReducer(state, action);
};
